export type EditableNumberField =
  | 'numberOfWorkers'
  | 'numberOfContractors'
  | 'shiftLengthHours'
  | 'avgWeeklyHours'
  | 'shiftType';

export const MAX_HEADCOUNT = 1000000;

export const NUMBER_FIELD_BOUNDS: Partial<Record<EditableNumberField, { min: number; max: number }>> = {
  numberOfWorkers: { min: 0, max: MAX_HEADCOUNT },
  numberOfContractors: { min: 0, max: MAX_HEADCOUNT },
  shiftLengthHours: { min: 0, max: 24 },
  avgWeeklyHours: { min: 0, max: 168 },
};

export const NUMBER_FIELD_LABELS: Partial<Record<EditableNumberField, string>> = {
  numberOfWorkers: 'Number of Employees',
  numberOfContractors: 'Number of Contractors',
  shiftLengthHours: 'Shift Length (hrs)',
  avgWeeklyHours: 'Avg Weekly Hours',
};

export function isNumberFieldOutOfRange(
  value: number | null | undefined,
  field: EditableNumberField,
): boolean {
  const bounds = NUMBER_FIELD_BOUNDS[field];
  if (!bounds || value === null || value === undefined) {
    return false;
  }
  const parsed = Number(value);
  if (Number.isNaN(parsed)) {
    return false;
  }
  return parsed < bounds.min || parsed > bounds.max;
}
